import React, { useState } from "react";
import "react-phone-number-input/style.css";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../styles/register.css";
import ownerForgot from "../services/owner-forget";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [phoneNo, setPhoneNo] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // inside your component

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPhoneNoError("");
    setApiResponse("");

    if (!phoneNo) {
      setPhoneNoError("Phone number is required.");
      return;
    }
    if (!validatePhone(phoneNo)) {
      setPhoneNoError("Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      setLoading(true);
      const response = await ownerForgot.forgotPassword(phoneNo);

      if (response.isSuccess) {
        const resetId = response?.result?.resetId;

        // ✅ Navigate to /reset-password with resetId
        navigate("/reset-password", {
          state: { resetId },
        });
      } else {
        setApiResponse(response.message || "Something went wrong.");
      }
    } catch (error) {
      setApiResponse(error.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="registration-section">
      <div className="container">
        <div className="login-form-wrap">
          {apiResponse && (
            <p
              className={`mt-3 ${
                apiResponse.toLowerCase().includes("error")
                  ? "text-danger"
                  : "text-success"
              }`}
            >
              {apiResponse}
            </p>
          )}
          <h2 className="form-title">Forgot Password</h2>
          <p>Reset password with curenza</p>
          <div className="user-guide-note">
            <div className="content-wrap">
              <span className="content">
                Enter your phone number and instructions will be sent to you!
              </span>
            </div>
          </div>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Phone Number <span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="phoneNo"
                    placeholder="Enter your phone number"
                    value={phoneNo}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D/g, "");
                      if (onlyDigits.length <= 10) {
                        setPhoneNo(onlyDigits);
                      }
                    }}
                    isInvalid={!!phoneNoError}
                    maxLength={10}
                  />
                  <Form.Control.Feedback type="invalid">
                    {phoneNoError}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Button
              type="submit"
              className="btn orange-btn w-100 button-register"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Request Link"}
            </Button>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
